import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-686cb132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mr-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "30",
  width: "30"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-cadac" })
], -1))
const _hoisted_8 = { class: "mb-0 text-bold" }
const _hoisted_9 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_10 = { class: "ml-1" }
const _hoisted_11 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_12 = { class: "product-config-step-subtitle" }
const _hoisted_13 = {
  key: 0,
  class: "mb-0 text-bold"
}
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = {
  key: 1,
  class: "mb-0 text-bold"
}
const _hoisted_16 = { class: "px-2" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "text-muted lead text-right" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProductConfigurationStep = _resolveComponent("ProductConfigurationStep")!
  const _component_Column = _resolveComponent("Column")!
  const _component_AvatarGroup = _resolveComponent("AvatarGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProductConfiguration = _resolveComponent("ProductConfiguration")!
  const _component_ProductOverviewItemCard = _resolveComponent("ProductOverviewItemCard")!
  const _component_ProductPageContentSection = _resolveComponent("ProductPageContentSection")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_ProductConfigurationSummaryItem = _resolveComponent("ProductConfigurationSummaryItem")!
  const _component_ProductConfigurationSummary = _resolveComponent("ProductConfigurationSummary")!
  const _component_ProductPageSummary = _resolveComponent("ProductPageSummary")!
  const _component_ProductLayout = _resolveComponent("ProductLayout")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProductLayout, { vm: _ctx.vm }, {
      configuration: _withCtx(() => [
        _createVNode(_component_ProductConfiguration, { class: "mb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_ProductConfigurationStep, { id: "step-software" }, {
              header: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("product.lblChooseSoftware")), 1),
                (_ctx.vm.supportContract?.endDate)
                  ? (_openBlock(), _createBlock(_component_PopoverIcon, {
                      key: 0,
                      class: "d-inline-flex text-info",
                      placement: "right"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("p", null, [
                          _createVNode(_component_i18n_t, { keypath: "product.message.contractRenewalDate" }, {
                            date: _withCtx(() => [
                              _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(_ctx.vm.supportContract.endDate)), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              error: _withCtx(() => [
                (
								!_ctx.supportProductValidation.get(_ctx.SupportValidationEnum.AtleastOneAsset) && _ctx.submitted
							)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      id: `validation-msg-${_ctx.SupportValidationEnum.AtleastOneAsset}`,
                      closable: false,
                      severity: "error"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("product.message.atleastOneAsset")), 1)
                      ]),
                      _: 1
                    }, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (!_ctx.layoutStore.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      closable: false,
                      severity: "custom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_i18n_t, { keypath: "product.message.alreadyHaveSupportLogin" }, {
                          loginLink: _withCtx(() => [
                            _createElementVNode("a", { href: _ctx.loginPageUrl }, _toDisplayString(_ctx.$t("common.login")), 9, _hoisted_3)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.selectedProducts,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProducts) = $event)),
                    "force-selection": "",
                    "min-length": 2,
                    multiple: true,
                    "option-label": "title",
                    placeholder: _ctx.$t('myCadac.supportOverview.autocomplete.placeholder'),
                    suggestions: _ctx.searchProductResults,
                    onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearchTrigger($event)))
                  }, {
                    option: _withCtx(({ option }) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          (option.icon)
                            ? (_openBlock(), _createBlock(_component_Avatar, {
                                key: 0,
                                alt: "product-icon",
                                class: "mr-1 bg-transparent",
                                image: option.icon,
                                shape: "square"
                              }, null, 8, ["image"]))
                            : (_openBlock(), _createBlock(_component_Avatar, {
                                key: 1,
                                alt: "product-icon",
                                class: "mr-1 bg-transparent",
                                shape: "square"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              })),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(option.title), 1)
                        ]),
                        (_ctx.selectedContract)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(
													(option.yearPrice / 12) * _ctx.selectedContract?.remainingMonths
												)), 1),
                              _createElementVNode("span", _hoisted_10, " ( " + _toDisplayString(_ctx.$t("myCadac.supportOverview.autocomplete.yearPrice", {
													price: _ctx.formatCurrency(option.yearPrice),
												})) + " ) ", 1)
                            ]))
                          : (_openBlock(), _createElementBlock("b", _hoisted_11, _toDisplayString(_ctx.$t("myCadac.supportOverview.autocomplete.yearPrice", {
												price: _ctx.formatCurrency(option.yearPrice),
											})), 1))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "suggestions"]),
                  _createVNode(_component_Button, {
                    class: "p-button-primary",
                    icon: "pi pi-search"
                  })
                ]),
                (_ctx.hasNoSearchResults)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 1,
                      closable: false,
                      severity: "warn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportOverview.autocomplete.msgNoResults", { query: _ctx.searchQuery })), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.vm.contractsForProduct?.length && !_ctx.vm.supportContract)
              ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                  key: 0,
                  id: "step-contract"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("product.lblChooseContract")), 1),
                    _createElementVNode("span", null, "(" + _toDisplayString(_ctx.$t("common.optional")) + ")", 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("product.lblChooseContract_subtitle")), 1)
                  ]),
                  default: _withCtx(() => [
                    (_ctx.vm.contractsForProduct?.length)
                      ? (_openBlock(), _createBlock(_component_DataTable, {
                          key: 0,
                          selection: _ctx.selectedContract,
                          "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedContract) = $event)),
                          "auto-layout": "",
                          "data-key": "contractNumber",
                          "meta-key-selection": false,
                          "selection-mode": "single",
                          value: _ctx.vm.contractsForProduct
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              class: "text-lg-center",
                              "selection-mode": "single",
                              style: {"width":"5%","padding":"1rem","overflow":"hidden"}
                            }),
                            _createVNode(_component_Column, {
                              key: "contractNumber",
                              field: "contractNumber",
                              header: _ctx.$t('contract.contractNumber')
                            }, {
                              body: _withCtx((item) => [
                                (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                      _createElementVNode("a", {
                                        href: "javascript:void(0)",
                                        title: _ctx.$t('common.goToCrm'),
                                        onClick: ($event: any) => (_ctx.openUrl(item.data.crmUrl, '_blank'))
                                      }, _toDisplayString(item.data.contractNumber), 9, _hoisted_14)
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(item.data.contractNumber), 1))
                              ]),
                              _: 1
                            }, 8, ["header"]),
                            (!_ctx.isSmallScreen)
                              ? (_openBlock(), _createBlock(_component_Column, {
                                  key: "products",
                                  header: _ctx.$t('contract.assets')
                                }, {
                                  body: _withCtx((item) => [
                                    _createVNode(_component_AvatarGroup, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data.contractAssets?.slice(
											0,
											_ctx.maxContractAssetsToShow
										), (asset, index) => {
                                          return (_openBlock(), _createBlock(_component_Avatar, {
                                            key: index,
                                            alt: asset.iconAlt,
                                            class: "ml-0 bg-transparent",
                                            image: asset.icon,
                                            shape: "square",
                                            size: "small",
                                            title: asset.productName
                                          }, null, 8, ["alt", "image", "title"]))
                                        }), 128)),
                                        (item.data.contractAssets?.length > _ctx.maxContractAssetsToShow)
                                          ? (_openBlock(), _createBlock(_component_Avatar, {
                                              key: 0,
                                              class: "text-bold ml-0",
                                              label: `+${item.data.contractAssets?.length - _ctx.maxContractAssetsToShow}`,
                                              shape: "square",
                                              size: "small"
                                            }, null, 8, ["label"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                }, 8, ["header"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_Column, {
                              key: "endDate",
                              field: "endDate",
                              header: _ctx.$t('contract.endDate')
                            }, {
                              body: _withCtx((item) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.data.endDate)), 1)
                              ]),
                              _: 1
                            }, 8, ["header"]),
                            _createVNode(_component_Column, {
                              key: "remainingTerm",
                              header: _ctx.$t('contract.remainingDuration')
                            }, {
                              body: _withCtx((item) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$tc("common.months", item.data.remainingMonths)), 1)
                              ]),
                              _: 1
                            }, 8, ["header"])
                          ]),
                          _: 1
                        }, 8, ["selection", "value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.vm.relatedUpSellProducts?.length)
          ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
              key: 0,
              type: "upsell"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t("product.titleUpSell")), 1),
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.relatedUpSellProducts, (product) => {
                    return (_openBlock(), _createElementBlock("div", { key: product }, [
                      _createVNode(_component_ProductOverviewItemCard, {
                        item: product,
                        layout: "grid"
                      }, null, 8, ["item"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      summary: _withCtx(() => [
        _createVNode(_component_ProductPageSummary, {
          "can-submit": !_ctx.submitted || !_ctx.validateProductConfiguration(),
          "is-product-available": _ctx.vm.viewModelIsValid,
          "total-price": _ctx.priceSummary?.totalPrice,
          onAddToCart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addSupportProductToCart()))
        }, {
          priceSummary: _withCtx(() => [
            _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"]),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("common.productSummary.allPricesExclVat")), 1)
          ]),
          configurationSummary: _withCtx(() => [
            _createVNode(_component_ProductConfigurationSummary, {
              header: _ctx.$t('product.titleSummarySupport')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  content: 
								_ctx.$tc(
									`common.months`,
									_ctx.vm.supportContract?.remainingMonths || _ctx.selectedContract?.remainingMonths || 12
								)
							,
                  label: _ctx.$t('myCadac.contractDetail.table.colDuration')
                }, null, 8, ["content", "label"]),
                _createVNode(_component_ProductConfigurationSummaryItem, {
                  label: _ctx.$t('cart.table.colSoftware')
                }, {
                  content: _withCtx(() => [
                    (_ctx.selectedProducts?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_AvatarGroup, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProducts, (product, index) => {
                                return (_openBlock(), _createBlock(_component_Avatar, {
                                  key: index,
                                  alt: product.iconAlt,
                                  class: "bg-transparent",
                                  image: product.icon,
                                  shape: "square",
                                  size: "large",
                                  title: product.title
                                }, null, 8, ["alt", "image", "title"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("common.none")), 1))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          validationMessage: _withCtx(() => [
            (_ctx.validationErrors.length && _ctx.submitted)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  closable: false,
                  severity: "warn",
                  style: {"cursor":"pointer"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToFirstValidationError()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("common.productSummary.msgValidationErrors", _ctx.validationErrors.length)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["can-submit", "is-product-available", "total-price"])
      ]),
      default: _withCtx(() => [
        (_ctx.$slots.blocks)
          ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
              key: 0,
              type: 'content'
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "blocks", {}, undefined, true)
              ]),
              _: 3
            }))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["vm"]),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 0,
          vm: _ctx.productAddedVm
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}